import { useMemo } from 'react';

export const useBoardEffectiveInteractionMode = options => {
  const {
    interactionMode = 'select',
    tool = 'select',
    isSpacePressed = false,
    toolFallbackMode = interactionMode,
  } = options || {};

  return useMemo(() => {
    if (tool !== 'select') {
      return toolFallbackMode;
    }
    if (!isSpacePressed) {
      return interactionMode;
    }
    return interactionMode === 'pan' ? 'select' : 'pan';
  }, [interactionMode, isSpacePressed, tool, toolFallbackMode]);
};
